import {Component, Input, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

import { ScrollPanel } from 'primeng/scrollpanel';

import { MenuItemCustom } from './../framework/MenuItemCustom.interface';
import { AppComponent } from 'src/app/app.component';
import { Usuario } from 'src/app/seguranca/usuario/usuario/usuario.model';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { PoiType } from 'src/app/homecare/gis/poi/poi.model';
import { RetiradaComponent } from 'src/app/farmacia/estoque/retirada/retirada.component';
import { AmbienteService } from '../multi-tenancy/ambiente.service';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { IItemMenuLateral } from './model/item-menu-lateral.model';


@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  styleUrls: ['./app.menu.component.css']
})
export class AppMenuComponent implements OnInit, AfterViewInit {

  public isGEEO = false;

  // icones dos modulos
  public static MAT_ICON_FARMACIA = 'store';
  public static MAT_ICON_HOMECARE = 'home';
  public static MAT_ICON_QUESTIONARIO = 'assignment';
  public static MAT_ICON_SEGURANCA = 'security';
  public static MAT_ICON_DASHBOARD = 'dashboard';
  public static MAT_ICON_SALA_MEDICACAO = 'local_hospital';
  public static MAT_ICON_CONFIGURACAO = 'settings';
  public static MAT_ICON_DISCOVERY = 'south_america';

  @Input() reset: boolean;

  arquivoLogoPequena = '';
  arquivoLogoAbreviadaColorida = '';

  model: IItemMenuLateral[];
  usuarioLogado: Usuario = UsuarioService.getUsuarioFromLocalStorage();

  @ViewChild('scrollPanel') layoutMenuScrollerViewChild: ScrollPanel;

  constructor(
      public app: AppComponent
      , private usuarioService: UsuarioService
      , private ambienteService: AmbienteService
  ) {}


  ngOnInit() {
    this.isGEEO = this.ambienteService.isGEEO();
    this.model = this.prepararMenu();

    this.carregarAmbiente();
  }

  ngAfterViewInit() {
    setTimeout(() => {this.layoutMenuScrollerViewChild.moveBar(); }, 100);

  }

  carregarAmbiente(): void {
    const ambiente = this.ambienteService.getAmbiente();
    if ( ambiente ) {

      this.arquivoLogoPequena = ambiente.getArquivoLogoPequena();
      if ( this.isGEEO ) {
        this.arquivoLogoAbreviadaColorida = ambiente.getArquivoLogoPequenaColorida();
      }
      else {
        this.arquivoLogoAbreviadaColorida = ambiente.getArquivoLogoPequena();
      }

      try {
        const favIcon: HTMLLinkElement = document.querySelector('#appIcon');
        favIcon.href = ambiente.getFavicon();
      }
      catch(e) {
        console.error(e);
      }
    }
  }

  temQualquerDasPermissoes(...permissaoNome: PermissaoNome[]): boolean {
    const permissoes: Array<PermissaoNome> = this.usuarioService.getUsuarioLogadoListaDePermissoes();
    return permissoes.some( o => permissaoNome.includes(o) );
  }

  temPermissao(permissao: PermissaoNome): boolean {
    return this.usuarioService.usuarioLogadoTemPermissao(permissao);
  }




  changeTheme(theme) {
      const themeLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('theme-css');
      themeLink.href = 'assets/theme/theme-' + theme + '.css';
  }

  changeLayout(theme) {
      const layoutLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('layout-css');
      layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
  }
  
  private esconderMenus(menus: IItemMenuLateral[]): void {
    for (const item of menus) {
      this.esconderItemMenu(item);
    }
  }

  private esconderItemMenu(item: IItemMenuLateral): void {
    const possuiFilhoAgrupador = this.possuiFilhoAgrupador(item);
    if ( possuiFilhoAgrupador ) {
      for ( const filho of item.items ) {
        this.esconderItemMenu(filho);
      }
    }

    const qntFilhosVisiveis = this.contarFilhosVisiveis(item);
    if ( qntFilhosVisiveis === 0 ) {
      item.visible = false;
    }
  }

  private possuiFilhoAgrupador(item: IItemMenuLateral): boolean {
    if ( item.items ) {
      for ( const filho of item.items ) {
        const ehAgrupador: boolean = (filho.items && filho.items.length > 0 ? true : false);
        if ( ehAgrupador ) {
          return true;
        }
      }
    }

    return false;
  }

  private contarFilhosVisiveis(item: IItemMenuLateral): number {
    let filhosVisiveis = null;
    if ( item.items ) {
      filhosVisiveis = 0;
      for ( const filho of item.items ) {
        if ( filho.visible ) {
          filhosVisiveis++;
        }
      }
    }

    return filhosVisiveis;
  }

  private getMenuEstoque(): IItemMenuLateral {
  return {
    label: 'Mat Med',
    icon: AppMenuComponent.MAT_ICON_FARMACIA,
    visible: true,
    items: [
      {
        label: 'Produtos',
        icon: 'subject',
        visible: true,
        items: [
          {
            label: 'Equipamento',
            fa_icon: 'fa fa-stethoscope',
            routerLink: ['farmacia/equipamento-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_EQUIPAMENTO)
          }
          , {
            label: 'Medicamento',
            icon: 'colorize',
            routerLink: ['farmacia/medicamento-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_MEDICAMENTO)
          }
          , {
            label: 'Material',
            fa_icon: 'fa fa-medkit',
            routerLink: ['farmacia/material-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_MATERIAL)
          }
        ]
      }
      ,{
        label: 'Controle',
        icon: 'subject',
        visible: true,
        items: [
          {
              label: 'Estoque',
              icon: 'get_app',
              routerLink: ['farmacia/entrada-de-produto/item-estoque'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_LOTE)
            }
          , {
            label: 'Setor',
            icon: 'inbox',
            routerLink: ['farmacia/inventario-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_INVENTARIO)
          }
          // , { label: 'Setor',  icon: 'inbox', routerLink: ['farmacia/inventario-home-card'] }
          , {
            label: 'Baixa',
            icon: 'subject',
            routerLink: [RetiradaComponent.URL_LISTAGEM_DE_BAIXAS],
            visible: this.temPermissao(PermissaoNome.ROLE_EFETUAR_BAIXA_DE_PRODUTO)
          }
          , {
              label: 'Retirada',
              icon: 'subject',
              routerLink: [RetiradaComponent.URL_LISTAGEM_DE_SOLICITACOES],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RETIRADA)
          }
          , {
              label: 'Movimentação',
              icon: 'subject',
              routerLink: ['farmacia/movimentacao-de-produto-home-lista'],
              visible: (this.temPermissao(PermissaoNome.ROLE_PESQUISAR_LOTE) && this.temPermissao(PermissaoNome.ROLE_ACESSAR_TODAS_UNIDADES) )
          }
        ]
      }
      ,{
        label: 'NF-e',
        icon: 'subject',
        visible: true,
        items:
        [
          {
            label: 'Importação',
            icon: 'subject',
            routerLink: ['farmacia/produto/nfe/importacao/importacao-nfe-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_IMPORTACAO_NFE)
          }
        ]
      }
      , {
          label: 'Relatório',
          icon: 'assessment',
          visible: true,
          items:
          [
            {
              label: 'Análise de vencimento',
              title: 'Análise de vencimento',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-analise-vencimento', ''],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_ESTOQUE)
            }
            , {
              label: 'Consumo e baixa',
              title: 'Relatório de consumo e baixa',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-de-consumo'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_ESTOQUE)
            }
            , {
              label: 'Geral de estoque',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-geral-estoque'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_ESTOQUE)
            }
            , {
              label: 'Insumos por paciente',
              icon: 'subject',
              routerLink: ['sala-de-medicacao/relatorio/relatorio-medicacao-lote'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_MEDICACAO_LOTE)
            }
            , {
              label: 'Mov. de estoque',
              title: 'Movimentação de estoque',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-movimentacao-estoque'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_ESTOQUE)
            }
            , {
              label: 'Mov. de setor',
              title: 'Movimentação de setor',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-movimentacao-inventario'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_INVENTARIO)
            }
            , {
              label: 'Nota fiscal',
              title: 'Relatório de notas fiscais',
              icon: 'subject',
              routerLink: ['farmacia/relatorio/relatorio-nota-fiscal'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_NOTA_FISCAL)
            }
          ]
        },
        {
          label: 'Configuração',
          icon: AppMenuComponent.MAT_ICON_CONFIGURACAO,
          visible: true,
          items:
          [
            {
              label: 'Categoria de produto',
              icon: 'subject',
              routerLink: ['farmacia/categoria-produto-lista'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_CATEGORIA_PRODUTO)
            }
            , {
              label: 'Tipo de baixa',
              icon: 'subject',
              routerLink: ['farmacia/tipo-de-baixa-de-produto-lista'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_TIPO_DE_BAIXA_DE_PRODUTO)
            }
            , {
              label: 'Alerta',
              icon: 'notifications',
              routerLink: ['seguranca/alerta-home'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_ALERTA)
            }
            , {
              label: 'Unidade',
              icon: 'business',
              routerLink: ['farmacia/unidade-lista'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_UNIDADE)
            }
          ]
        }
    ]
   }
  }

  private getMenuSeguranca(): IItemMenuLateral {
    return {
      label: 'Segurança',
      icon: AppMenuComponent.MAT_ICON_SEGURANCA,
      visible: true
      , items: [
          { label: 'Organizações',
            icon: 'subject',
            visible: this.temQualquerDasPermissoes(PermissaoNome.ROLE_MASTER_PESQUISAR_TENANT,
                                                   PermissaoNome.ROLE_MASTER_PESQUISAR_CATALOGO_USUARIO),
            items: [
              {
                label: 'Organização',
                icon: 'subject',
                routerLink: ['seguranca/tenant-lista'],
                visible: this.temPermissao(PermissaoNome.ROLE_MASTER_PESQUISAR_TENANT)
              }
              , {
                  label: 'Catálogo de usuários',
                  icon: 'subject',
                  routerLink: ['seguranca/catalogo-usuario-lista'],
                  visible: this.temPermissao(PermissaoNome.ROLE_MASTER_PESQUISAR_CATALOGO_USUARIO)
                }
            ]
          }
          , {
              label: 'Meu perfil',
              icon: 'face',
              routerLink: ['seguranca/usuario-tabmenu', '' + this.usuarioLogado.getId()],
              visible: true
            }
          , {
              label: 'Usuário',
              icon: 'people',
              routerLink: ['seguranca/usuario-lista'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_USUARIO)
            }
          , {
              label: 'Paciente',
              icon: 'people_outline',
              routerLink: ['homecare/paciente-lista'],
              visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_PACIENTE)
            }
          , {
              label: 'Autenticar App',
              icon: 'phonelink_lock',
              routerLink: ['seguranca/autenticar-app'],
              visible: true
            }
          , {
              label: 'Relatório',
              icon: 'assessment',
              visible: true,
              items:
              [
                {
                  label: 'Permissões por perfil',
                  icon: 'subject',
                  routerLink: ['seguranca/relatorio/relatorio-de-permissoes'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_PERMISSOES_POR_PERFIL)
                }
                ,
                {
                  label: 'Usuários por perfil',
                  icon: 'subject',
                  routerLink: ['seguranca/relatorio/relatorio-de-usuarios-por-perfil'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_USUARIOS_POR_PERFIL)
                }
              ]
            }
          , {
              label: 'Configurações',
              icon: 'settings',
              visible: true,
              items:
              [
                {
                  label: 'Parâmetro',
                  icon: 'subject',
                  routerLink: ['seguranca/configuracao/configuracao-lista'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_PARAMETRO)
                },
                {
                  label: 'Perfil de acesso',
                  icon: 'assignment',
                  routerLink: ['seguranca/mosaico-de-permissao'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_PERFIL)
                },
                {
                  label: 'Rotina',
                  icon: 'memory',
                  routerLink: ['seguranca/rotina-lista'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_ROTINA)
                },
                {
                  label: 'Pol. de privacidade',
                  icon: 'subject',
                  routerLink: ['seguranca/politica-de-privacidade-lista'],
                  visible: this.temPermissao(PermissaoNome.ROLE_CADASTRAR_POLITICA_DE_PRIVACIDADE)
                },
                {
                  label: 'Integração de APIs',
                  icon: 'code',
                  routerLink: ['seguranca/configuracao/cfg-integracao-home'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO)
                },
                {
                  label: 'Assinatura digital',
                  icon: 'fingerprint',
                  routerLink: ['seguranca/configuracao/assinatura-digital-home'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO)
                },
                {
                  label: 'Release notes',
                  icon: 'new_releases',
                  routerLink: ['seguranca/configuracao/release-note-lista'],
                  visible: this.temPermissao(PermissaoNome.ROLE_CADASTRAR_RELEASE_NOTE)
                }
              ]
            }
      ]
   }
  }

  private getMenuAtencaoDomiciliar(): IItemMenuLateral {
    return {
      label: 'Atenção Domiciliar',
      icon: AppMenuComponent.MAT_ICON_HOMECARE,
      visible: true,
      items: [
          {
            label: 'Rotas',
            icon: 'gesture',
            routerLink: ['homecare/rota-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_ROTA_HOMECARE)
          }
          , {
              label: 'Pontos de interesse',
              icon: 'place',
              visible: true,
              items:
              [
                {
                  label: 'Ponto de partida',
                  icon: 'subject',
                  routerLink: ['/homecare/poi-lista', PoiType.PONTO_INICIO_PROFISSIONAL],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_POI_HOMECARE)
                },
                {
                  label: 'Ponto de atendimento',
                  icon: 'subject',
                  routerLink: ['/homecare/poi-lista', PoiType.LOCAL_ATENDIMENTO],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_POI_HOMECARE)
                }
              ]
            }
            , {
              label: 'Relatório',
              icon: 'assessment',
              visible: true,
              items: [
                {
                  label: 'Km Percorrido',
                  icon: 'subject',
                  routerLink: ['homecare/relatorio/relatorio-km-percorrido-form'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_KM_PERCORRIDO)
                }
                , {
                  label: 'Atendimento',
                  icon: 'subject',
                  routerLink: ['homecare/relatorio/relatorio-atendimento-form'],
                  visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_RELATORIO_ATENDIMENTO)
                }
              ]
            }
      ]
   }
  }

  private getMenuSalaAtendimento(): IItemMenuLateral {
    return {
      label: 'Sala de Atendimento',
      icon: AppMenuComponent.MAT_ICON_SALA_MEDICACAO,
      visible: true,
      items: [
        {
          label: 'Atendimento',
          icon: 'subject',
          routerLink: ['sala-de-medicacao/sala-de-medicacao-home'],
          visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_ATENDIMENTO_SALA)
        }
        , {
          label: 'Alergia',
          icon: 'subject',
          routerLink: ['sala-de-medicacao/alergia-lista'],
          visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_ALERGIA)
        }
        , {
          label: 'Sala',
          icon: 'subject',
          routerLink: ['sala-de-medicacao/sala-de-medicacao-lista'],
          visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_SALA_MEDICACAO)
        }
      ]
     }
  }

  private getMenuQuestionario(): IItemMenuLateral {
    return {
      label: 'Questionário',
      icon: AppMenuComponent.MAT_ICON_QUESTIONARIO,
      visible: true,
      items:
      [
          {
            label: 'Questão',
            icon: 'subject',
            routerLink: ['questionario/questao-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_QUESTIONARIO)
          },
          {
            label: 'Questionário',
            icon: 'subject',
            routerLink: ['questionario/questionario-lista'],
            visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_QUESTIONARIO)
          }
      ]
    }
  }

  prepararMenu(): IItemMenuLateral[] {
    let menu: IItemMenuLateral[] = [
      // { label: 'Dashboard', icon: 'dashboard', routerLink: ['/']  },
    this.getMenuAtencaoDomiciliar(),
    this.getMenuEstoque(),
    this.getMenuQuestionario(),
    this.getMenuSalaAtendimento(),
    this.getMenuSeguranca(),
    {
      label: 'Mapa',
      icon: 'map',
      routerLink: ['homecare/mapa'],
      visible: this.temPermissao(PermissaoNome.ROLE_CADASTRAR_ROTA_HOMECARE)
    }
    , {
      label: 'Discovery',
      icon: AppMenuComponent.MAT_ICON_DISCOVERY,
      routerLink: ['mapa/mapa'],
      visible: this.temPermissao(PermissaoNome.ROLE_PESQUISAR_PACIENTE)
    }
    // , {
    //     label: 'Menu', icon: 'settings',
    //     items: [
    //         {label: 'Static Menu', icon: 'view_quilt', command: (event) => {this.app.layoutMode = 'static'; }},
    //         {label: 'Overlay Menu', icon: 'flip_to-front', command: (event) => {this.app.layoutMode = 'overlay'; }},
    //         {label: 'Horizontal Menu', icon: 'border_horizontal', command: (event) => {this.app.layoutMode = 'horizontal'; }}
    //     ]
    // }
    ];

    this.esconderMenus(menu)

    /* necessario chamar 2x para remover menu principal ( modulos ) */
    // menu.forEach(item => {
    //   this.esconderMenuSemFilhosVisiveis(null, item);
    // });
    // menu.forEach(item => {
    //   this.esconderMenuSemFilhosVisiveis(null, item);
    // });

    return menu;
  }
}

@Component({
  /* tslint:disable:component-selector */
  selector: '[app-submenu]',
  /* tslint:enable:component-selector */
  template: `
      <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
          <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass" *ngIf="child.visible" [title]="child.title ? child.title : ''">
              <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink"
                 [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                 (mouseenter)="onMouseEnter(i)" class="ripplelink">
                  <i *ngIf="child.icon" class="material-icons">{{child.icon}}</i>
                  <i *ngIf="child.fa_icon" class="{{child.fa_icon}}"></i>
                  <span class="menuitem-text">{{child.label}}</span>
                  <i class="material-icons layout-submenu-toggler" *ngIf="child.items">keyboard_arrow_down</i>
                  <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
              </a>

              <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
                  [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                 [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                 (mouseenter)="onMouseEnter(i)" class="ripplelink">
                  <i *ngIf="child.icon" class="material-icons">{{child.icon}}</i>
                  <i *ngIf="child.fa_icon" class="{{child.fa_icon}}"></i>
                  <span class="menuitem-text">{{child.label}}</span>
                  <i class="material-icons layout-submenu-toggler" *ngIf="child.items">>keyboard_arrow_down</i>
                  <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
              </a>
              <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
                  [@children]="(app.isHorizontal())&&root ? isActive(i) ?
                  'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
          </li>
      </ng-template>
  `,
  animations: [
      trigger('children', [
          state('hiddenAnimated', style({
              height: '0px'
          })),
          state('visibleAnimated', style({
              height: '*'
          })),
          state('visible', style({
              height: '*',
              'z-index': 100
          })),
          state('hidden', style({
              height: '0px',
              'z-index': '*'
          })),
          transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
          transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
      ])
  ]
})
export class AppSubMenuComponent {

  @Input() item: MenuItemCustom;

  @Input() root: boolean;

  @Input() visible: boolean;

  _reset: boolean;

  activeIndex: number;

  constructor(public app: AppComponent, public router: Router, public location: Location, public appMenu: AppMenuComponent) {}

  itemClick(event: Event, item: MenuItemCustom, index: number) {
      if (this.root) {
          this.app.menuHoverActive = !this.app.menuHoverActive;
      }

      // avoid processing disabled items
      if (item.disabled) {
          event.preventDefault();
          return true;
      }

      // activate current item and deactivate active sibling if any
      if (item.routerLink || item.items || item.command || item.url) {
          this.activeIndex = (this.activeIndex as number === index) ? -1 : index;
      }

      // execute command
      if (item.command) {
          item.command({originalEvent: event, item: item});
      }

      // prevent hash change
      if (item.items || (!item.url && !item.routerLink)) {
        setTimeout(() => {
          this.appMenu.layoutMenuScrollerViewChild.moveBar();
        }, 450);
          event.preventDefault();
      }

      // hide menu
      if (!item.items) {
          if (this.app.isMobile()) {
              this.app.sidebarActive = false;
              this.app.mobileMenuActive = false;
          }

          if (this.app.isHorizontal()) {
              this.app.resetMenu = true;
          } else {
              this.app.resetMenu = false;
          }

          this.app.menuHoverActive = !this.app.menuHoverActive;
      }
  }

  onMouseEnter(index: number) {
      if (this.root && this.app.menuHoverActive && this.app.isHorizontal()
          && !this.app.isMobile() && !this.app.isTablet()) {
          this.activeIndex = index;
      }
  }

  isActive(index: number): boolean {
      return this.activeIndex === index;
  }

  @Input() get reset(): boolean {
      return this._reset;
  }

  set reset(val: boolean) {
      this._reset = val;

      if (this._reset && (this.app.isHorizontal() || this.app.isOverlay())) {
          this.activeIndex = null;
      }
  }
}
